import invariant from 'tiny-invariant';

import { GraphPageState } from './../types';
import { resetGraphChartType } from './utils/reset-graph-chart-type';

export const removeParameters = (
  graphSet: GraphPageState,
  graphId: string,
  parameterUniqueIds: string[],
): GraphPageState => {
  const graphs = graphSet.structure.graphs;

  const graphToModify = graphs.get(graphId);
  invariant(
    graphToModify,
    'Trying to remove a parameter from a non-existant graph',
  );

  parameterUniqueIds.forEach((parameterUniqueId) =>
    graphToModify.parameters.delete(parameterUniqueId),
  );

  const modifiedGraph = resetGraphChartType(graphSet, graphToModify);

  graphs.set(graphId, modifiedGraph);

  return {
    ...graphSet,
    structure: {
      ...graphSet.structure,
      graphs,
    },
  };
};
